import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Box, CheckboxCard } from '@chakra-ui/react';

const QUERY_KEY = key => `pub_${key}`;

const parseValueFromUrl = (search, key) => {
  const params = new URLSearchParams(search);
  const value = params.get(QUERY_KEY(key));

  return value ? value : false;
};

const SearchFiltersBoolean = props => {
  const { id: key, filterConfig, updateQueryParams } = props;

  const { label } = filterConfig;

  const location = useLocation();

  // ---- LOCAL STATE (fast UI)
  const [selectedValue, setSelectedValue] = useState(() => parseValueFromUrl(location.search, key));

  // ---- URL → STATE sync (back / forward / external updates)
  useEffect(() => {
    const fromUrl = parseValueFromUrl(location.search, key);
    setSelectedValue(fromUrl);
  }, [location.search]);

  // ---- STATE → URL
  const handleChange = ({ checked: value }) => {
    setSelectedValue(value); // instant UI

    updateQueryParams({
      [QUERY_KEY(key)]: value ? value : null,
    });
  };

  return (
    <Box>
      <CheckboxCard.Root
        align="center"
        rounded={'xl'}
        value={selectedValue}
        checked={selectedValue}
        onCheckedChange={handleChange}
        size={'lg'}
        bgColor={selectedValue ? 'gray.50' : null}
        cursor="pointer"
      >
        <CheckboxCard.HiddenInput />
        <CheckboxCard.Control>
          <CheckboxCard.Content>
            <CheckboxCard.Label>{label}</CheckboxCard.Label>
          </CheckboxCard.Content>
        </CheckboxCard.Control>
      </CheckboxCard.Root>
    </Box>
  );
};

export default SearchFiltersBoolean;
